module.exports = __webpack_public_path__ + "img/6.5f3e7a99.webp";